"use strict";

exports.__esModule = true;
exports.YAxisFields = void 0;
var _react = _interopRequireDefault(require("react"));
var _Translator = require("../../../Core/Translator");
var _MeasureTimelineSelector = require("../../common/MeasureTimelineSelector/MeasureTimelineSelector");
var _helper = require("../helper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var YAxisFields = exports.YAxisFields = function YAxisFields(props) {
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var element = props.element,
    elementEditor = props.elementEditor,
    path = props.path,
    selectedColor = props.selectedColor;
  var handleSelectMeasure = function handleSelectMeasure(item) {
    var measureChartSeries = item.map(function (item) {
      return Object.assign({}, item, {
        color: selectedColor
      });
    });
    elementEditor.setProp(path, "measureChartSeries", measureChartSeries);
  };
  return /*#__PURE__*/_react["default"].createElement(_helper.Well, null, /*#__PURE__*/_react["default"].createElement(_helper.WellTitle, null, translate("MetricChartFields.axes.xaxis.label", "Y Axis")), /*#__PURE__*/_react["default"].createElement(_MeasureTimelineSelector.MeasureTimelineSelector, {
    selectedMeasure: element.props.measureChartSeries,
    handleMeasureSelect: handleSelectMeasure
  }), /*#__PURE__*/_react["default"].createElement(_helper.AxisControls, null, /*#__PURE__*/_react["default"].createElement(_helper.CheckboxEl, _extends({
    propName: "hideYAxis",
    defaultLabel: "Hide Axis"
  }, props)), /*#__PURE__*/_react["default"].createElement(_helper.CheckboxEl, _extends({
    propName: "hideYLabel",
    defaultLabel: "Hide Label"
  }, props))));
};